import React, { useState, useEffect } from 'react';
import { Button } from './button';
import { Input } from './input';
import { Field } from './fieldset';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase'; // Import your Firebase instance
import { useBranding } from '../hooks/useBranding';
//import logo from '../public/logo.png';

const Login = () => {
  const branding = useBranding();
  // One color is enough — fill the missing side from the other.
  const gradFrom = branding.colorPrimario || branding.colorSecundario;
  const gradTo = branding.colorSecundario || branding.colorPrimario;
  const hasCustomColors = Boolean(gradFrom);

  useEffect(() => {
    document.title = `Inicia Sesión | ${branding.nombreComercial}`;
    return () => { document.title = branding.nombreComercial; };
  }, [branding.nombreComercial]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard/home'); // Redirect to dashboard after successful login
    } catch (err) {
      setError('Invalid email or password. Please try again.');
    }
  };

  return (
    <div
      className={`flex min-h-screen items-center justify-center relative overflow-hidden ${hasCustomColors ? '' : 'bg-gradient-to-br from-azul-surelia to-azul-surelia/80'}`}
      style={hasCustomColors ? { background: `linear-gradient(to bottom right, ${gradFrom}, ${gradTo})` } : {}}
    >
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className={`absolute top-1/4 left-1/4 w-64 h-64 rounded-full blur-3xl ${branding.isWhiteLabel ? 'bg-white' : 'bg-verde-lima'}`}></div>
        <div className={`absolute bottom-1/4 right-1/4 w-48 h-48 rounded-full blur-3xl ${branding.isWhiteLabel ? 'bg-sky-200' : 'bg-cian-digital'}`}></div>
      </div>

      {/* Logo outside the card */}
      <div className="relative z-10 w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <img
            src={branding.logoUrl}
            alt={branding.nombreComercial}
            className="w-auto h-20"
          />
        </div>

        <div className="p-8 bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl border border-azul-surelia/20">

          <div className="text-center mb-8">
            <h3 className="text-xl font-semibold text-azul-surelia mb-2">Acceso al Sistema</h3>
          </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && <p className="text-sm text-red-600">{error}</p>}
          
          <Field>
            <label htmlFor="email" className="text-sm font-medium text-azul-surelia">
              Correo electrónico
            </label>
            <Input
              id="email-eventobot"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="usuario@ejemplo.com"
              required
            />
          </Field>
          <Field>
            <label htmlFor="password" className="text-sm font-medium text-azul-surelia">
              Contraseña
            </label>
            <Input
              id="password-eventobot"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder=""
              required
            />
          </Field>
          <div className="pt-2">
            <Button type="submit" color="surelia" className="w-full">
              Iniciar Sesión
            </Button>
          </div>
        </form>
        
        <div className="mt-4 text-center">
          <div className="text-center">
            <a href="/forgot-password" className="text-sm text-azul-surelia/70 hover:text-azul-surelia hover:underline font-medium">
              ¿Olvidaste tu contraseña?
            </a>
          </div>
        </div>
        </div>

        {branding.isWhiteLabel && (
          <div className="flex items-center justify-center mt-8">
            <img src='/logo-blanco-verde.png' alt="Surelia" className="w-auto h-12" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
